<template>
  <div class="info-region-container" style="margin-right: 30px; overflow-x: none; width: 100%; height: 100vh" v-allow="'0902'">
    <div class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <h4>用户管理</h4>
          <!-- <el-button type="primary" class="adduser" @click="add">添加</el-button> -->
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="账号：">
            <el-input v-model="formInline.user" placeholder="请输入账号" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="昵称：">
            <el-input v-model="formInline.nink" placeholder="请输入昵称" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="角色：">
            <el-select v-model="formInline.role" placeholder="请选择角色">
              <el-option v-for="item in allSysRoleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="组织结构:">
            <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="formInline.organization" :options="departList" :props="optionProps" clearable placeholder="组织结构"></el-cascader>
          </el-form-item> -->
          <el-form-item v-allow="'090201'">
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="button" @click="usrReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1">
          <el-table :data="tableData" align="center" v-loading="loading" :header-cell-style="{ background: '#f4f5f7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="username" align="center" label="账号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nick" align="center" label="昵称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="roleName" align="center" label="角色" show-overflow-tooltip></el-table-column>
            <el-table-column prop="departName" align="center" label="组织机构" show-overflow-tooltip></el-table-column>
            <el-table-column prop="realName" align="center" label="姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mobile" align="center" label="手机号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qq" align="center" label="QQ" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" align="center" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">
                  <span class="show-line show-rline"></span>
                  冻结
                </div>
                <div v-if="scope.row.status == 1">
                  <span class="show-line show-bline"></span>
                  启用
                </div>
              </template>
            </el-table-column>
            <el-table-column style="border: 0" fixed="right" align="center" label="操作" width="250">
              <template style="border: 0" slot-scope="scope">
                <!-- <el-button @click="handleChild(scope.row)" type="text" size="small">子账号</el-button> -->
                <el-button @click="handleClick(scope.row.id, 'edit')" type="text" size="small">编辑</el-button>
                <!-- <el-button type="text" size="small" @click="del(scope.row.id)">删除</el-button> -->
                <!-- <el-button
                  v-allow="'090205'"
                  @click="handleClick(scope.row.id, 'frozen')"
                  type="text"
                  size="small"
                  v-if="scope.row.status == 1"
                  >冻结</el-button
                >
                <el-button
                  v-allow="'090205'"
                  @click="handleClick(scope.row.id, 'enable')"
                  type="text"
                  size="small"
                  v-if="scope.row.status == 0"
                  >启用</el-button
                >
                <el-button
                  v-allow="'090203'"
                  @click="handleClick(scope.row.id, 'edit')"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  v-allow="'090204'"
                  type="text"
                  size="small"
                  @click="del(scope.row.id)"
                  >删除</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="730px" center style="z-index: 10000" :before-close="resetForm">
          <div class="info-content-container info-content-container-add">
            <el-form :inline="true" :model="dialogformInline" :rules="dialogRules" ref="dialogformInline" style="margin-left: 50px; margin-left: 0 !important">
              <el-row>
                <el-col :span="12" style="dispaly: flex">
                  <div class="grid-content bg-purple">
                    <el-form-item label="账号：" prop="username" label-width="100px">
                      <el-input style="width: 202px" v-model="dialogformInline.username" placeholder="请输入账号" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="密码：" prop="password" label-width="100px">
                      <el-input style="width: 202px" type="password" v-model="dialogformInline.password" placeholder="请输入密码" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="昵称：" prop="nink" label-width="100px">
                      <el-input v-model="dialogformInline.nink" placeholder="请输入昵称" maxlength="50" style="width: 202px"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="角色：" prop="role" label-width="100px">
                      <el-select style="width: 202px" v-model="dialogformInline.role" placeholder="请选择角色">
                        <el-option v-for="item in allSysRoleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="组织机构：" prop="departId" label-width="100px">
                      <el-cascader style="width: 202px" @change="changeTreeItem2" :show-all-levels="false" v-model="dialogformInline.departId" :options="departList" :props="optionProps" clearable placeholder="请选择组织结构"></el-cascader>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="姓名：" prop="realName" label-width="100px">
                      <el-input style="width: 202px" v-model="dialogformInline.realName" placeholder="请输入姓名" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="性别：" prop="gender" label-width="100px">
                      <el-select v-model="dialogformInline.gender" placeholder="请选择性别" style="width: 202px">
                        <el-option v-for="item in genderList" :key="item.id" :label="item.name" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="手机号：" label-width="100px" prop="mobile">
                      <el-input style="width: 202px" v-model="dialogformInline.mobile" placeholder="请输入手机号" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="邮箱：" label-width="100px" prop="email">
                      <el-input style="width: 202px" v-model="dialogformInline.email" class="transferS" placeholder="请输入邮箱" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="QQ：" label-width="100px" prop="qq">
                      <el-input style="width: 202px" v-model="dialogformInline.qq" class="transferS" placeholder="请输入QQ" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm">取 消</el-button>
            <el-button type="primary" @click="submitForm('dialogformInline')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userManagementone',
  data() {
    return {
      pwd: '',
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover',
        checkStrictly: true
      },
      dialogTitle: '',
      pagesize: 8,
      currentPage: 1,
      total: 0,
      loading: false, //加载
      centerDialogVisible: false, //添加弹框
      email: '',
      qq: '',
      status: '',
      allSysRoleList: [], //全部角色
      genderList: [
        {
          value: '0',
          name: '男'
        },
        {
          value: '1',
          name: '女'
        }
      ],

      formInline: {
        //查询条件（参数）
        user: '',
        role: '',
        nink: '',
        organization: ''
      },
      dialogformInline: {
        //添加参数或者编辑参数
        username: '', //账号
        role: '', // 角色
        nink: '', // 昵称
        departId: '', // 组织机构
        password: '', //密码
        realName: '', //姓名
        gender: '', //性别
        mobile: '', //手机号
        email: '', //邮箱
        qq: '',
        roleID: ''
      },
      dialogRules: {
        // 弹框表单验证
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        nink: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: /^[\w_-]{6,40}$/, //正则
            message: '请输入（长度为6~18位的密码）'
          }
        ],
        departId: [{ required: true, message: '请选择组织机构', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        nink: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [
          { required: false, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/, //正则
            message: '请输入正确的手机号'
          }
        ],
        qq: [
          { required: false, message: '请输入QQ', trigger: 'blur' },
          {
            pattern: /^[1-9][0-9]{4,9}$/, //正则
            message: '请输入正确的QQ'
          }
        ],
        email: [
          { required: false, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, //正则
            message: '请输入正确的邮箱'
          }
        ]
      },
      tableData: [],
      departList: [],
      searchId: ''
    }
  },

  created() {
    this.init()
  },
  methods: {
    resetForm() {
      this.centerDialogVisible = false
      this.$refs['dialogformInline'].resetFields()
      this.dialogformInline = {
        //添加参数或者编辑参数
        username: '', //账号
        role: '', // 角色
        nink: '', // 昵称
        departId: '', // 组织机构
        password: '', //密码
        realName: '', //姓名
        gender: '', //性别
        mobile: '', //手机号
        email: '', //邮箱
        qq: '',
        roleID: ''
      }
    },
    handleChange(e, form, thsAreaCode) {
      // thsAreaCode = this.form.areaCode    // 注意1：获取value值
      var thsAreaCode = this.$refs['cascaderAddr'].currentLabels //注意2： 获取label值
      console.log(thsAreaCode) // 注意3： 最终结果是个一维数组对象
    },
    init() {
      this.getUserMessageList() //列表信息
      this.getAllSysRole() //全部角色
      this.getDepartList() //获取组织机构
    },
    handleCurrentChange(currentPage) {
      //下一页
      this.currentPage = currentPage
      this.getUserMessageList() //查询列表
    },
    // 查询
    onSubmit() {
      this.currentPage = 1
      this.getUserMessageList() //查询列表
    },
    //列表信息
    getUserMessageList() {
      this.$api.system
        .getUserMessageList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.formInline.organization, //机构id
          this.email, //邮箱地址,
          this.editTd, //主键id
          this.name, //真实姓名
          this.formInline.nink, //昵称
          this.phone, //手机号
          this.qq, //qq
          this.formInline.role, //角色id
          this.sex, // 性别0男1女
          this.status, //状态（0启用，1冻结）
          this.formInline.user //账号
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          }
        })
    },
    //删除按钮
    del(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$api.system.delfun(`/pc/sysUser/delSysUser`, id).then((res) => {
            if (res.code == 200) {
              this.getUserMessageList()
              this.$message({
                type: 'success',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    add() {
      //添加
      this.dialogTitle = '添加用户'
      this.centerDialogVisible = true
      this.editTd = ''
      this.getDepartList()
    },
    handleClick(id, type) {
      if (type == 'edit') {
        this.dialogTitle = '编辑用户'
        this.centerDialogVisible = true
        this.editTd = id
        this.getUserDetails(id) //编辑详情

        this.getDepartList()
      } else if (type == 'frozen') {
        this.$confirm('是否冻结?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.setfrozen(id) //启动  冻结
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消冻结'
            })
          })
      } else if (type == 'enable') {
        this.$confirm('是否启用?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.setfrozen(id) //启动  冻结
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消启用'
            })
          })
      }
    },
    //重置
    usrReset() {
      this.formInline.user = ''
      this.formInline.nink = ''
      this.formInline.role = ''
      this.formInline.searchId = ''
      this.formInline.organization = ''
      this.getUserMessageList()
    },
    submitForm(formName, id) {
      // 提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == '添加用户') {
            //为添加新用户
            this.newUsersData() // 新增
          } else {
            //为编辑dialogformInline
            this.newUsersData() //编辑
          }
        } else {
          return false
        }
      })
    },
    cancellation() {
      //弹框取消时
      this.centerDialogVisible = false
    },
    //添加用户是的接口 this.dialogformInline.departId
    newUsersData() {
      if (isNaN(this.dialogformInline.role)) {
        this.allSysRoleList.map((s, index) => {
          if (s.name === this.dialogformInline.role) {
            this.dialogformInline.role = this.allSysRoleList[index].id
          }
        })
      }
      if (isNaN(this.dialogformInline.departId)) {
        this.departList.map((s, index) => {
          if (s.name === this.dialogformInline.departId) {
            this.dialogformInline.departId = this.departList[index].id
          }
        })
      }
      this.loading = true //开启加载
      if (this.dialogformInline.password == this.pwd) {
        this.dialogformInline.password = this.dialogformInline.password
      } else {
        this.dialogformInline.password = this.$utils.calcuMD5(this.dialogformInline.password)
      }
      console.log(this.editTd)
      this.$api.system
        .newUsersData(
          this.dialogformInline.username, //账号
          this.dialogformInline.role, // 角色
          this.dialogformInline.nink, // 昵称
          this.dialogformInline.departId, // 组织机构
          this.dialogformInline.password, //密码
          this.dialogformInline.realName, //姓名
          (this.dialogformInline.gender = this.dialogformInline.gender),
          this.dialogformInline.mobile, //手机号
          this.dialogformInline.email, //邮箱
          this.dialogformInline.qq,
          0,
          this.editTd
        )
        .then((res) => {
          if (res.code == 200) {
            this.loading = false //关闭加载
            this.formInline.organization = ''
            this.getUserMessageList() //刷新列表
            this.$message({ type: 'success', message: res.msg })
            this.resetForm()
            this.centerDialogVisible = false
          } else {
            this.loading = false //关闭加载
          }
        })
    },
    //编辑列表数据接口
    setUserMessageList() {
      this.loading = true //开启加载
      this.$api.system.setUserMessageList().then((res) => {
        if (res.code == 200) {
          this.loading = false //关闭加载
          this.$message({ type: 'success', message: res.msg })
        } else {
          this.loading = false //关闭加载
        }
      })
    },
    //冻结接口 启动
    setfrozen(id) {
      this.$api.system.setfrozen(id).then((res) => {
        if (res.code == 200) {
          this.getUserMessageList() ///
          this.$message({ type: 'success', message: res.msg })
        }
      })
    },
    //获取详情
    getUserDetails(id) {
      this.$api.system.getUserDetails(id).then((res) => {
        if (res.code == 200) {
          this.dialogformInline.roleID = res.data.roleId
          this.dialogformInline.role = res.data.roleId
          this.dialogformInline.username = res.data.username
          this.dialogformInline.nink = res.data.nick
          this.pwd = res.data.password
          this.dialogformInline.departId = res.data.departId
          this.dialogformInline.password = res.data.password
          this.dialogformInline.realName = res.data.realName
          this.dialogformInline.gender = res.data.gender.toString()
          this.dialogformInline.mobile = res.data.mobile
          this.dialogformInline.email = res.data.email
          this.dialogformInline.qq = res.data.qq
          this.dialogformInline.id = res.data.id
        }
      })
    },
    //获取全部角色
    getAllSysRole() {
      this.$api.system
        .getAllSysRole()
        .then((res) => {
          if (res.code == 200) {
            this.allSysRoleList = res.data //全部角色
          }
        })
        .catch((err) => {
          this.$message.info(err)
        })
    },
    //组织机构
    getDepartList() {
      this.$api.system
        .getDepartList(
          0 //0为中国
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data
          }
        })
    },
    changeTreeItem(val) {
      this.formInline.organization = val[val.length - 1]
    },
    changeTreeItem2(val) {
      this.dialogformInline.departId = val[val.length - 1]
    },
    // 子账号
    handleChild(row) {
      this.$router.push({
        name: 'childManagement',
        query: { parentId: row.id }
      })
    }
  }
}
</script>
<style  scope lang="scss">
@import '../../style/userManagementone.scss';

.th.is-leaf {
  border: 0 !important;
}
</style>